type TConfig = {
  common: string[];
  feature: string;
};

export const carouselTranslationConfig: TConfig = {
  common: ['CommonUI.Controls'],
  feature: 'Feature.GameDetails'
};

export const ratingsTranslationConfig: TConfig = {
  common: ['CommonUI.Controls'],
  feature: 'Feature.GameDetails'
};

export const socialLinksTranslationConfig: TConfig = {
  common: ['CommonUI.Controls'],
  feature: 'Feature.PromotedChannels'
};

export default {
  carouselTranslationConfig,
  ratingsTranslationConfig,
  socialLinksTranslationConfig
};
